export const colors: {[key: string]: string} = {
  IDLE: '#97EE81',
  MISSION: '#9ACCE9',
  ERROR: '#FF5858',
};
  